<template>
  <div class="charts-page">
    <div class="vx-row justify-center">
      <div class="vx-col w-full sm:w-full mb-base">
        <vx-card>
          <div class="vx-row flex items-center  md:items-start">
            <div class="vx-col w-full  md:w-1/2 lg:w-2/3 xl:w-2/3 mb-4">
              <div class="flex">
                <div class="w-full pr-3">
                  <span class="flex item-center">
                    <feather-icon
                      icon="ArrowLeftCircleIcon"
                      svgClasses="w-6 h-6 hover:text-primary stroke-current"
                      @click.stop="cancelPage"
                      style="cursor: pointer"
                    />
                    <span class="h4 ml-2 text-truncate">{{ deviceName }}</span>
                  </span>
                </div>
              </div>
            </div>
            <div
              class="
                vx-col
                w-full
                md:w-1/2
                lg:w-1/3
                xl:w-1/3
                text-center
                sm:text-right
              "
            >
            <date-picker
                v-model="RangePickerValue"
                range
                append-to-body
                confirm
                :shortcuts="daterangeShortcuts"
                :format="'YYYY-MM-DD HH:mm'"
                :clearable="false"
                class="w-full mb-1"
                range-separator=" ~ "
                align="right"
                :placeholder="$t('date.placeholder')"
                :confirm-text="$t('date.applyBtn')"
                :disabled-date="disabledEndDate"
                @input="handlePeriodChange"
                @confirm="clickConfirmButton"
              ></date-picker>
            </div>
          </div>
        </vx-card>
      </div>
    </div>
    <vx-card class="mb-base" :title="$t('hives.detail.charts.Temperature')">
        <template v-if="isTempChartLoading == true">
            <page-loader :size="'w-10 h-10'" :height="300" class="charts-page__loading" />
        </template>
        <template v-else-if="!isTempChartLoading && temperatureData.insideTemp.length>0">
            <temperature-chart  :chartData="temperatureData" />
            <div class="flex items-center justify-center mt-6">
                <div class="mr-3 custom-legend-area"></div>
                <div class="font-size-14">
                    {{ $t("hives.detail.charts.BroodZone") }}
                </div>
            </div>
        </template>
        
        <template v-else-if="!isTempChartLoading && temperatureData.insideTemp.length==0" >
            <div class="text-center flex items-center justify-center w-full charts-page__noData">
                <p>{{$t('hives.detail.charts.NoChartDataMessage.Temperature')}}</p>
            </div>
        </template>
    </vx-card>
        <vx-card class="mb-base" :title="$t('hives.detail.charts.Humidity')">
        <template v-if="isHumidityChartLoading == true">
            <page-loader :size="'w-10 h-10'" :height="300" class="charts-page__loading" />
        </template>
        <template v-else-if="!isHumidityChartLoading && humidityChartData.insideHum.length>0">
            <humidity-chart  :chartData="humidityChartData" />
        </template>
        
        <template v-else-if="!isHumidityChartLoading && humidityChartData.insideHum.length==0" >
            <div class="text-center flex items-center justify-center w-full charts-page__noData">
                <p>{{$t('hives.detail.charts.NoChartDataMessage.Humidity')}}</p>
            </div>
        </template>
    </vx-card>
    <template v-if="version=='V2'">
        <vx-card class="mb-base" :title="$t('hives.detail.charts.Weight')">
            <template v-if="isWeightChartLoading == true">
                <page-loader :size="'w-10 h-10'" :height="300" class="charts-page__loading" />
            </template>
            <template v-else-if="!isWeightChartLoading && weightChartData.weight.length>0">
                <weight-chart  :chartData="weightChartData" />
            </template>
            
            <template v-else-if="!isWeightChartLoading && weightChartData.weight.length==0" >
                <div class="text-center flex items-center justify-center w-full charts-page__noData">
                    <p>{{$t('hives.detail.charts.NoChartDataMessage.Weight')}}</p>
                </div>
            </template>
        </vx-card>
    </template>
  </div>
</template>

<script type="text/javascript">
import i18n from '../../../../i18n/i18n.js'
const language = i18n.locale

import TemperatureChart from './components/temperature-chart.vue'
import HumidityChart from './components/humidity-chart.vue'
import WeightChart from './components/weight-chart.vue'
const moment = require('moment')

import DatePicker from 'vue2-datepicker'
require('vue2-datepicker/index.css')
require(`vue2-datepicker/locale/${language}`)

import PageLoader from '../../../../components/Loader.vue'

export default {
  components: {
    TemperatureChart,
    HumidityChart,
    WeightChart,
    DatePicker,
    PageLoader
  },
  computed: {
    currentQueryParameterDevice () {
      return this.$store.getters.returnCurrentQueryParameterAnalytics
    },
    temperatureData () {
      return this.$store.getters.tempAndHumChartData.temp
    },
    humidityChartData () {
      return this.$store.getters.tempAndHumChartData.hum
    },
    hiveData () {
      return this.$store.getters.hiveData
    }
  },
  watch: {
    hiveData:{
      handler () {
        this.isPageLoading = true
        this.getHiveData()
      },
      deep: true,
      immediate: true
    },
    RangePickerValue () {
      let currentRange = ''
      if (currentRange !== this.RangePickerValue && this.RangePickerValue) {
        this.$store.dispatch('currentQueryParameter', {
          value: [
            moment(this.RangePickerValue[0]),
            moment(this.RangePickerValue[1])
          ],
          index: 1
        })
      }
      currentRange = [
        moment(this.RangePickerValue[0]),
        moment(this.RangePickerValue[1])
      ]
      this.isTempChartLoading = true
      this.isHumidityChartLoading = true
      this.getOutsideTemperatureAndHumidityData()
    }
  },
  created () {
    this.$store.dispatch('currentQueryParameter', [])
  },
  methods: {
    clickConfirmButton (val) {
      this.RangePickerValue = [
        new Date(moment(val[0]).startOf('day')),
        new Date(moment(val[1]).endOf('day'))
      ]
    },
    handlePeriodChange (date) {
      if (date) {
        if (!date[0] && !date[1]) {
          this.RangePickerValue = [
            new Date(moment().startOf('hour')),
            new Date(moment())
          ]
        }
      }
    },
    cancelPage () {
      this.$router.push(`/hives/hive/${  this.$route.params.id}`)
    },
    getHiveData () {
      const hive = this.hiveData
      this.deviceName = hive.name
      this.hiveID = hive.id
      this.userID = hive.user.id

      this.version = hive.device.version
           
      const lat = hive.apiary && hive.apiary.lat
        ? hive.apiary.lat
        : 0
      const lng = hive.apiary && hive.apiary.lng
        ? hive.apiary.lng
        : 0
      
      this.$store.dispatch('currentQueryParameter', {
        value: [lat, lng],
        index: 3
      })

      this.$store.dispatch('currentQueryParameter', {
        value: hive.apiary.id,
        index: 4
      })

      this.$store.dispatch('currentQueryParameter', {
        value: hive.id,
        index: 0
      })
      this.getDeviceData(hive.device.id)
    },
    getDeviceData (id) {
      this.$store
        .dispatch('getDeviceData', id)
        .then((response) => {
          if (response.data) {
            this.deviceSerial = response.data.device_serial
              ? response.data.device_serial
              : '-'
            this.$store.dispatch('currentQueryParameter', {
              value: response.data.id,
              index: 2
            })
            this.RangePickerValue = [
              new Date(moment().subtract(6, 'days').startOf('day')),
              new Date(moment())
            ]
          }
          this.isPageLoading = false
        })
        .catch((error) => {
          this.isPageLoading = false
          this.$router.push('/hives')
          this.errorMsg(error)
        })
    },
    getChartData () {
      this.isTempChartLoading = true
      this.isHumidityChartLoading = true
      this.$store
        .dispatch('getChartData')
        .then(() => {
          this.isTempChartLoading = false
          this.isHumidityChartLoading = false
        })
        .catch((error) => {
          this.isTempChartLoading = false
          this.isHumidityChartLoading = false
          this.errorMsg(error)
        })
    },

    getOutsideTemperatureAndHumidityData () {
      this.isHumidityChartLoading = true
      this.$store
        .dispatch('getOutsideTemperatureAndHumidityData')
        .then(() => {
          this.getChartData()
        })
        .catch((error) => {
          this.getChartData()
          this.errorMsg(error)
        })
    },
    disabledEndDate (date) {
      return date > new Date(moment().endOf('day'))
    },
    errorMsg (error) {
      this.$store.dispatch('errorMsg', error).then((res) => {
        this.$vs.notify({
          title: i18n.t('notifyAlert.error.title'),
          text: res,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
          position: 'top-right'
        })
      })
    }
  },
  data () {
    return {
      deviceName: '-',
      deviceSerial: '-',
      isPageLoading: true,
      isTempChartLoading: true,
      isHumidityChartLoading: true,
      hiveID: null,
      userID: null,
      isWeightChartLoading: false,
      weightChartData:{
        weight:[],  
        categories:[]  
      },
      version:'V1',
      daterangeShortcuts: [
        {
          text: i18n.t('date.Today'),
          onClick () {
            return [new Date(moment().startOf('day')), new Date(moment())]
          }
        },
        {
          text: i18n.t('date.Yesterday'),
          onClick () {
            return [
              new Date(moment().subtract(1, 'days').startOf('day')),
              new Date(moment().subtract(1, 'days').endOf('day'))
            ]
          }
        },
        {
          text: i18n.t('date.LastWeek'),
          onClick () {
            return [
              new Date(moment().subtract(6, 'days').startOf('day')),
              new Date(moment())
            ]
          }
        },
        {
          text: i18n.t('date.LastMonth'),
          onClick () {
            return [
              new Date(moment().subtract(29, 'days').startOf('day')),
              new Date(moment())
            ]
          }
        },
        {
          text: i18n.t('date.LastTwoMonth'),
          onClick () {
            return [
              new Date(moment().subtract(2, 'months').startOf('day')),
              new Date(moment())
            ]
          }
        },
        {
          text: i18n.t('date.LastFourMonth'),
          onClick () {
            return [
              new Date(moment().subtract(4, 'months').startOf('day')),
              new Date(moment())
            ]
          }
        },
        {
          text: i18n.t('date.LastSixMonth'),
          onClick () {
            return [
              new Date(moment().subtract(6, 'months').startOf('day')),
              new Date(moment())
            ]
          }
        },
        {
          text: i18n.t('date.LastYear'),
          onClick () {
            return [
              new Date(moment().subtract(1, 'years').startOf('day')),
              new Date(moment())
            ]
          }
        },
        {
          text: i18n.t('date.LastTwoYear'),
          onClick () {
            return [
              new Date(moment().subtract(2, 'years').startOf('day')),
              new Date(moment())
            ]
          }
        }
      ],
      RangePickerValue: [
        new Date(moment().subtract(6, 'days').startOf('day')),
        new Date(moment())
      ]
    }
  }
}
</script>
<style lang="scss">
.charts-page{
    .charts-page__noData{
        height: 300px;
        background: rgba(255,159,67,.15);
        border-radius: 0.5rem;
    }
    .charts-page__loading{
        height: 300px;
    }

    .custom-legend-area {
        width: 30px;
        height: 20px;
        background: #32b154;
        opacity: 0.2;
        color: #626262;
    }
}
</style>
<style media="scss" scoped>
.el-range-editor--small.el-input__inner {
  height: 32px;
  width: 400px;
}
@media (max-width: 767.98px) {
  .el-range-editor--small.el-input__inner {
    width: 100%;
  }
}

.alarm-icon .feather {
  width: 50px;
  height: 50px;
}
.height-380 {
  height: 380px;
}
.height-220 {
  height: 220px;
}
.alarm-icon.danger {
  background: rgba(var(--vs-danger), 0.15);
}
.alarm-icon.success {
  background: rgba(var(--vs-success), 0.15);
}

.alarm-icon.primary {
  background: rgba(var(--vs-primary), 0.15);
}

.alarm-icon.good {
  background: rgba(36, 193, 160, 0.15);
}

.text-good {
  color: rgba(36, 193, 160);
}

.alarm-icon.warning {
  background: rgba(var(--vs-warning), 0.15);
}

.battery-icon {
  transform: rotate(-90deg);
}
.no-device-card {
  background: rgba(var(--vs-warning), 0.1);
  border-radius: 0.5rem;
}

@media (max-width: 590px) {
  .device-action-buttons.flex {
    flex-direction: column !important;
  }
  .device-action-buttons button {
    width: 100% !important;
    margin: 10px 0px 0px 0px !important;
  }
}
</style>
<style lang="scss">
.clipboard-icon {
  display: none;
}

.hover\:show-clipboard:hover {
  .clipboard-icon {
    display: flex;
  }
}
</style>